import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';

export const BannerBlockContainer = styled(BlockContainer)`
    ${ListContainer} {
        z-index: 2;
    }
    
    img {
        position: absolute;
        height: 78px;
        right: 0;
        bottom: 0;
    
        @media (min-width: ${wideBreakpoints.mobile}) {
            right: 100px;
            height: auto;
        }
    }
`;
